import React from 'react';
import { Studio } from 'sanity';
import { MotionConfig } from 'framer-motion';
import config from './sanity.config';
import './App.css';
import TitleBar from './components/TitleBar';
import HeroSection from './components/HeroSection';
import IntroSection from './components/IntroSection';
import ModelFamily from './components/ModelFamily';
import Capabilities from './components/Capabilities';
import Benefits from './components/Benefits';
import VideoSection from './components/VideoSection';
import Footer from './components/Footer';

function App() {
  const isStudio = window.location.pathname.startsWith('/studio');

  if (isStudio) {
    return (
      <div style={{ height: '100vh', width: '100vw' }}>
        <Studio config={config} />
      </div>
    );
  }

  return (
    <MotionConfig reducedMotion="user">
    <div className="App">
      <TitleBar />

      {/* DARK sections */}
      <div data-theme="dark">
        <HeroSection />
        <IntroSection />
      </div>

      {/* LIGHT section */}
      <div data-theme="light">
        <ModelFamily />
      </div>

      {/* LIGHT section */}
      <div data-theme="light">
        <Capabilities />
      </div>

      {/* BACK TO DARK */}
      <div data-theme="dark">
        <Benefits />
        <VideoSection />
        <Footer />
      </div>
    </div>
    </MotionConfig>
  );
}

export default App;
